import styled from 'styled-components';

export const FlexCellContent = styled.div.attrs<{ className?: string }>({
  className: 'table-cell-content md:min-h-[88px]',
})`
  margin: 0;
  display: flex;
  align-items: center;

  .arrow-icon {
    transform: rotate(180deg);
    margin-left: 5px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease-in;

    &.active {
      transform: rotate(0deg);
    }
  }
`;
